import { Grid, Typography } from "@mui/material";
import React from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useHistory } from "react-router-dom";

import WhiteListCostumersTable from "./WhiteListCostumersTable";

const WhiteListCostumers = () => {
  const history = useHistory();
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          onClick={() => history.push("/license/AddCostumerToWhitelist")}
          sx={{ marginBottom: "15px" }}
        >
          <Typography
            color={"#28A745"}
            sx={{ cursor: "pointer", maxWidth: "fit-content" }}
          >
            <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
            <b style={{ fontSize: "1rem" }}>ثبت مجوز جدید</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <WhiteListCostumersTable />
        </Grid>
      </Grid>
    </>
  );
};

export default WhiteListCostumers;
